import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgHuis = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#85E3F9"
      fillRule="evenodd"
      d="m9 15 11-8 11 8v18H9z"
      clipRule="evenodd"
    />
    <path
      fill="#00C5F2"
      d="M20 21h-7v12h7z"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgHuis);

export default ForwardRef;
